export default __webpack_public_path__ + "static/java-d0be53e356542c3f88d263d7adcd95a9.png";